import React from "react";
import imageUrl from "../images/3-WEB_low.jpg";
import "../css/Contact.css";

const Contact = ({ content }) => {
  return (
    <div className="Contact">
      <img src={imageUrl} alt="contact" className="Contact__image" />
      <div
        className="Contact__html"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js